import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'trial-vouchers',
    pluginName: 'TRIAL_VOUCHER',
    entityName: 'TRIAL_VOUCHER',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch TrialVoucher action creators
export const fetchTrialVouchersInit = () => {
    return crudActions.fetchInit();
};
export const fetchTrialVouchersStart = () => {
    return crudActions.fetchStart();
};
export const fetchTrialVouchersSuccess = (fetchTrialVouchersCount, listTrialVouchersCount) => {
    return crudActions.fetchSuccess(fetchTrialVouchersCount, listTrialVouchersCount);
};
export const fetchTrialVouchersFail = () => {
    return crudActions.fetchFail();
};
export const fetchTrialVouchersCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchTrialVouchersStart());
        try {
            let countRes = await rest.post("/trial-vouchers/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchTrialVouchersSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchTrialVouchersFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch trial vouchers."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchTrialVouchersFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch trial vouchers."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchTrialVouchers = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchTrialVouchersStart());
        try {
            let listRes = await rest.post("/trial-vouchers/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchTrialVouchersSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchTrialVouchersFail());
            return []
        } catch (error) {
            dispatch(fetchTrialVouchersFail());
            return []
        }
    }
}

// Create TrialVoucher action creators
export const createTrialVoucherInit = () => {
    return crudActions.createInit();
};
export const createTrialVoucherStart = () => {
    return crudActions.createStart();
};
export const createTrialVoucherSuccess = TrialVoucher => {
    return crudActions.createSuccess(TrialVoucher);
};
export const createTrialVoucherFail = error => {
    return crudActions.createFail(error);
};
export const createTrialVoucher = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createTrialVoucherStart());
        try {
            let res = await rest.post('/trial-vouchers/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created trial voucher.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createTrialVoucherFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create trial voucher."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create trial voucher."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createTrialVoucherFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete TrialVoucher action creators
export const bulkDeleteTrialVoucherInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteTrialVoucherStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteTrialVoucherSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteTrialVoucherFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteTrialVoucher = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteTrialVoucherStart());
        try {
            let res = await rest.post('/trial-vouchers/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteTrialVoucherSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted trial vouchers.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteTrialVoucherFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete trial vouchers."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete trial vouchers."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteTrialVoucherFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete TrialVoucher action creators
export const deleteTrialVoucherInit = () => { return crudActions.deleteInit(); };
export const deleteTrialVoucherStart = () => { return crudActions.deleteStart(); };
export const deleteTrialVoucherSuccess = deletedTrialVoucher => { return crudActions.deleteSuccess(deletedTrialVoucher); };
export const deleteTrialVoucherFail = error => { return crudActions.deleteFail(error); };
export const deleteTrialVoucher = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

// Edit trialVoucher action creators
export const editTrialVoucherInit = () => {
    return crudActions.editInit();
};
export const editTrialVoucherStart = () => {
    return crudActions.editStart();
};
export const editTrialVoucherSuccess = editedTrialVoucher => {
    return crudActions.editSuccess(editedTrialVoucher);
};
export const editTrialVoucherFail = error => {
    return crudActions.editFail(error);
};
export const editTrialVoucher = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editTrialVoucherStart());
        try {
            let res = await rest.post('/trial-vouchers/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully edited trial voucher.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editTrialVoucherFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit trial voucher."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit trial voucher."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editTrialVoucherFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Load trialVoucher action creators
export const loadTrialVoucherInit = () => { return crudActions.loadInit(); };
export const loadTrialVoucherStart = () => { return crudActions.loadStart(); };
export const loadTrialVoucherSuccess = loadedTrialVoucher => { return crudActions.loadSuccess(loadedTrialVoucher); };
export const loadTrialVoucherFail = error => { return crudActions.loadFail(error); };
export const loadTrialVoucher = id => {
    return async dispatch => {

        await crudActions.load(dispatch, id);
    };
};

export const fetchPlans = (data, options) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/account/list-plans', { listAll: true, ...data }, options);
            if (res.data && res.data.succeeded) {
                let plans = [];
                for (var plan of res.data.result.data) {
                    plans.push({ value: plan.Plan.VersionID, displayValue: `${plan.Plan.Name}` });
                }
                return plans;
            } else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list plans."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}

// export const downloadPdf = (id, customerId) => {
//     let token = localStorage.getItem('SESSION');
//
//     return async dispatch => {
//         return fetch(`${config.backend_domain}:${config.backend_port}/trial-vouchers/download?TrialVoucherID=${id}&ActiveCustomerID=${customerId.ActiveCustomerID}&Token=${token}`, {
//             method: "GET",
//         }).then(response => {
//             if (response.status === 200) {
//                 return response.blob();
//             }
//             return null;
//         });
//     }
// }
//
// export const bulkDownloadPdf = (ids, customerId) => {
//     let token = localStorage.getItem('SESSION');
//
//     return async dispatch => {
//         return fetch(`${config.backend_domain}:${config.backend_port}/trial-vouchers/bulk_download?TrialVoucherIDs=${ids}&ActiveCustomerID=${customerId.ActiveCustomerID}&Token=${token}`, {
//             method: "GET",
//         }).then(response => {
//             if (response.status === 200) {
//                 return response.blob();
//             }
//             return null;
//         });
//     }
// }